import type { FC } from "react";
import { renderToString } from "react-dom/server";
import {
  Container,
  IconsFill,
  Link,
  MobilePhoneIcon,
  Row,
  TicketsOutlineIcon,
  TicketStarOutlineIcon,
} from "@viagogo/core/ui";
import { Content, FormatContent, useContent } from "src/shared/components/content";
import { useAppContext } from "src/shared/context/AppContext";
import { writeUrl } from "src/shared/utils/url-builder";
import {
  DetailsCard,
  DetailsCardIcon,
  DetailsContainer,
  SectionTitle,
  StyledArrow,
  StyledDetailCol,
} from "src/website-apps/responsive/stubhub-about-us/components/viagogo/styled-components";
import { MetricsBackground } from "src/website-apps/shared/components/branding/styled-components";
import { Arrow as ArrowSvg } from "./assets/Arrow";
import { Heart as HeartSvg } from "./assets/Heart";

export const Details: FC = () => {
  const appContext = useAppContext();
  const customerServiceLinkText = useContent("cid$#2984322#");

  return (
    <MetricsBackground>
      <DetailsContainer>
        <SectionTitle>
          <Content id="cid$#2984212#" />
        </SectionTitle>
        <Container>
          <Row>
            <StyledDetailCol span={[12, 12, 6, 3]}>
              <StyledArrow>
                <ArrowSvg />
              </StyledArrow>
              <DetailsCard>
                <DetailsCardIcon>
                  <TicketsOutlineIcon fill={IconsFill.currentColor} />
                </DetailsCardIcon>
                <div>
                  <Content id="cid$#2984311#" />
                </div>
              </DetailsCard>
            </StyledDetailCol>
            <StyledDetailCol span={[12, 12, 6, 3]}>
              <StyledArrow>
                <ArrowSvg />
              </StyledArrow>
              <DetailsCard>
                <DetailsCardIcon>
                  <TicketStarOutlineIcon fill={IconsFill.currentColor} />
                </DetailsCardIcon>
                <div>
                  <Content id="cid$#2984313#" />
                </div>
              </DetailsCard>
            </StyledDetailCol>
            <StyledDetailCol span={[12, 12, 6, 3]}>
              <StyledArrow>
                <ArrowSvg />
              </StyledArrow>
              <DetailsCard>
                <DetailsCardIcon>
                  <MobilePhoneIcon fill={IconsFill.currentColor} />
                </DetailsCardIcon>
                <div>
                  <FormatContent
                    id="cid$#2984318#"
                    params={[
                      renderToString(
                        <Link url={writeUrl("/contactus", null, appContext)}>{customerServiceLinkText}</Link>,
                      ),
                    ]}
                    raw
                  />
                </div>
              </DetailsCard>
            </StyledDetailCol>
            <StyledDetailCol span={[12, 12, 6, 3]}>
              <DetailsCard>
                <DetailsCardIcon>
                  <HeartSvg />
                </DetailsCardIcon>
                <div>
                  <Content id="cid$#2984319#" />
                </div>
              </DetailsCard>
            </StyledDetailCol>
          </Row>
        </Container>
      </DetailsContainer>
    </MetricsBackground>
  );
};
